import teamImage1 from "../assets/images/team-2.jpeg";
import teamImage2 from "../assets/images/team-3.jpeg";
import FadeInSection from "./FadeInSection";

function Philosophy() {
	return (
		<div className="philosophy-container">
			<div className="container">
				<FadeInSection animationType="fade-left">
					<h2>Our Philosophy</h2>
					<hr />
					<div className="row mt-5 gy-4">
						<div className="col-md-6">
							<p>
								Mane & Bare is a modern beauty collective rooted in the belief that true
								transformation begins with connection. We've moved away from the rushed salon
								experience to focus on intentional care and elevated artistry, ensuring every
								service is as unique as the individual in our chair. To us, beauty is more than an
								aesthetic—it is a practice. We believe your routine should feel grounding, personal,
								and empowering, serving as a quiet moment of reclamation in a busy world. Here, we
								don't just change how you look; we honor how you feel.
							</p>
						</div>
						<div className="col-md-6 philosophy-container-images">
							<img src={teamImage2} alt="Mane and Bare team 2" className="philosophy-image-2" />
							<img src={teamImage1} alt="Mane and Bare team 1" className="philosophy-image-1" />
						</div>
					</div>
				</FadeInSection>
			</div>
		</div>
	);
}

export default Philosophy;
